import todo from './todo';
import user from './user';
import router from './router';
import app from './app';

export default {
  todo,
  user,
  router,
  app,
};
